import { Sport } from '@betterpool/api-types/contests-service';
import { format } from 'date-fns';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';
import { findDefaultSlate } from '~/domains/games/services/find-default-slate.utils';

const getPickDeadlineValue = ({
  isPlayerBased,
  sport,
  pickDeadlineType,
  slates,
  t,
}: {
  sport: Sport;
  isPlayerBased: boolean;
  pickDeadlineType: FullContest['settings']['pickDeadlineType'];
  slates: ContestSlate[];
  t: (key: string, data?: Record<string, unknown>) => string;
}) => {
  if (isPlayerBased) {
    if (sport === Sport.GOLF) {
      return t('detail.about.info.pickDeadlineValue.tournament');
    }
    return;
  }

  if (pickDeadlineType === 'game') {
    return t('detail.about.info.pickDeadlineValue.game');
  }

  const currentSlate = findDefaultSlate(slates, true);
  if (currentSlate) {
    if (currentSlate.late_swap_deadline) {
      return format(
        new Date(currentSlate.late_swap_deadline),
        t('detail.about.info.pickDeadlineValue.dateTime', { slateName: currentSlate.name })
      );
    }
    const currentSlateIndex = slates.indexOf(currentSlate);
    const nextSlateWithLateSwap = slates
      .slice(currentSlateIndex)
      .find((slate) => slate.late_swap_deadline);

    if (nextSlateWithLateSwap) {
      return t('detail.about.info.pickDeadlineValue.slateForCurrentSlate', {
        slateName: currentSlate.name,
      });
    }
    return t('detail.about.info.pickDeadlineValue.slate');
  }

  return t('detail.about.info.pickDeadlineValue.slate');
};

export default getPickDeadlineValue;
